import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const InscricaoPage = lazy(() => import('../pages/inscricao/page'));
const ModulosPage = lazy(() => import('../pages/modulos/page'));
const InvestimentoPage = lazy(() => import('../pages/investimento/page'));
const EspecialistasPage = lazy(() => import('../pages/especialistas/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/inscricao',
    element: <InscricaoPage />,
  },
  {
    path: '/modulos',
    element: <ModulosPage />,
  },
  {
    path: '/investimento',
    element: <InvestimentoPage />,
  },
  {
    path: '/especialistas',
    element: <EspecialistasPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
